module.exports = __webpack_public_path__ + "static/media/icon-arrow.53ef8ed8.svg";